import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import Topbar from './pages/global/Topbar';
// import Invoices from './pages/invoices';
// import Contacts from './pages/contacts';
// import Form from './pages/form';
// import Bar from './pages/bar';
// import Line from './pages/line';
// import Pie from './pages/pie';
// import FAQ from './pages/faq';
// import Geography from './pages/geography';

// main pages
import ProjectDetails from './pages/project/ProjectDetails';
import ProjectListPage from './pages/project';
import Member from './pages/member';
import Team from './pages/team';
import TeamSettings from './pages/team/Settings';
import WorkPlanPage from './pages/plan';

import { useProjects } from './context/ProjectContext';
import { useTeam } from './context/TeamContext';
import { useMember } from './context/MemberContext';
import { AUTH_KEY_TOKEN, removeTokenByKey } from './utils/helper';

const AppRoutes = ({ isLogged }) => {
  const { fetchProjects } = useProjects();
  const { fetchTeams } = useTeam();
  const { fetchMembers } = useMember();

  // Load page
  useEffect(() => {
    if (isLogged) {
      Promise.all([fetchProjects(), fetchTeams(), fetchMembers()]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  useEffect(() => {
    if (!isLogged) {
      removeTokenByKey(AUTH_KEY_TOKEN);
    }
  }, [isLogged]);

  return (
    <main>
      {/* <Topbar /> */}
      <Routes>
        {/* <Route path="/" element={<Dashboard />} /> */}
        <Route path="/" element={<ProjectListPage />} />
        <Route path="/project" element={<ProjectListPage />} />
        <Route path="/plan" element={<WorkPlanPage />} />
        <Route path="/member" element={<Member />} />
        <Route path="/team" element={<Team />} />
        <Route path="/team/settings" element={<TeamSettings />} />
        <Route path="/team/:id" element={<Team />} />
        {/* <Route path="/calendar" element={<ProjectDetails />} />
        <Route path="/calendar/:id" element={<ProjectDetails />} /> */}
        <Route path="/project/:id" element={<ProjectDetails />} />

        {/* <Route path="/contacts" element={<Contacts />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/form" element={<Form />} />
        <Route path="/bar" element={<Bar />} />
        <Route path="/pie" element={<Pie />} />
        <Route path="/line" element={<Line />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/geography" element={<Geography />} /> */}
      </Routes>
    </main>
  );
};

export default AppRoutes;
